import React, {useContext} from "react";
import clsx from "clsx";
import {createUseStyles, useTheme} from "react-jss";
import {EngageAppContext} from "../../App";
import {Role} from "engage-common/types";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";

const BoxHeightLG = 30;
const BoxHeightMD = 25;
const BoxHeightXS = 20;

const BoxWidthLG = 24;
const BoxWidthMD = 20;
const BoxWidthXS = 16;

//TODO:Need to figure out how to do multiple computed properties within one class
// @ts-ignore
const useStyles = createUseStyles<Theme>((theme) => {
    const circleCounter = theme.accessoryPanel.participantCounter === "circle";
    return {
        participantCounter: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignContent: "flex-end",
        },
        counter: {
            display: "flex",
            justifyContent: "flex-end",
            alignContent: "center",
            paddingRight: 20,
        },
        label: {
            lineHeight: `${BoxHeightLG}px`, //if lineHeight == height of div, centers text.
            height: BoxHeightLG,
            [theme.breakpoints.between("sm", "md")]: {
                lineHeight: `${BoxHeightMD}px`,
                height: BoxHeightMD,
            },
            [theme.breakpoints.only("xs")]: {
                lineHeight: `${BoxHeightXS}px`,
                height: BoxHeightXS,
            },
            marginRight: 6,
            color: theme.accessoryPanel.textColor ?? "white",
            fontWeight: 400
        },
        participantNumber: {
            color: "white",
            fontWeight: 700,
            marginLeft: 10
        },
        url: {
            textAlign: "right",
            marginTop: 8,
            paddingBottom: theme.accessoryPanel.leaderboard.removeBackgroundSVG ? 10 : 0,
            paddingRight: 20,
            borderBottom: theme.accessoryPanel.leaderboard.removeBackgroundSVG ? `1px solid ${theme.accessoryPanel.textColor ?? "white"}` : "",
        }
    };
});

type ParticipantCounterProps = {
    className?: string
    showURL:boolean
}

export default function ParticipantCounter({className, showURL}: ParticipantCounterProps) {
    const {appState, lobby, user} = useContext(EngageAppContext.current);
    const url = showURL && window && lobby && user?.role === Role.host ?
        `${window.location.origin}/j/${lobby.id}` : undefined;
    return <PureParticipantCounter url={url} participantCount={appState.extra.participantCount} className={className}/>;
}

type PureParticipantCounterProps = {
    url?: string
    participantCount: number
    className?: string
}

export function PureParticipantCounter({url, participantCount, className}: PureParticipantCounterProps) {
    const classes = useStyles();
    const theme:Theme = useTheme();
    return (
        <div className={clsx(classes.participantCounter, className)}
             data-qa="participant-counter" data-value={participantCount}>
            <div className={classes.counter}>
                <DisplayText variant={TextVariant.s20med} className={classes.label}>
                    Participants: <span className={classes.participantNumber}>{participantCount}</span>
                </DisplayText>
            </div>
            {url && (<DisplayText variant={TextVariant.s18med} color="white" className={classes.url}>
                {url}
            </DisplayText>)}
        </div>


    );
}